<template>
<v-menu v-model="menu" :close-on-content-click="false">
    <template v-slot:activator="{ on }">

        <!-- <v-chip pill v-on="on" dark outlined="">
            <v-avatar left color="white">
                <v-img :src="`https://www.redmedica.ugto.mx/WebServices/Main/Temp/${nue}B00000.png`">
                    <template v-slot:placeholder>
                        <v-img :src="require('@/assets/perfil_default.png')" />
                    </template>
                </v-img>
            </v-avatar>
            {{ email }}
        </v-chip> -->
        <v-btn fab icon v-on="on" style="margin-right: 0px;">
            <v-avatar size="40">
                <v-img :src="require('@/assets/perfil_default.png')" />
            </v-avatar>
        </v-btn>

    </template>

    <v-card width="300" class="text-center">
       
            <v-img class="ma-3" max-width="150px" :src="require('@/assets/perfil_default.png')" />

       

      
            <v-card-title v-if="nombre" class="pt-0 pb-2">{{nombre}}</v-card-title>
       
      
            <v-card-title v-if="empleadoDatos.Id_Empleado" class="subtitle-2 pa-5"> Nue: {{empleadoDatos.Id_Empleado}}</v-card-title>
     
    
            <v-card-title v-if="empleadoDatos.Email" class="subtitle-2 py-2 pb-5"> {{empleadoDatos.Email}}</v-card-title>
     

        <v-divider></v-divider>

   
            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="Es_Alumno" color="primary" v-on="on"> mdi-account-edit</v-icon>
                </template>
                <span>Estudiante</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="Es_Acad" color="primary" v-on="on">mdi-teach</v-icon>
                </template>
                <span>Académico</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="Es_Admtvo" color="primary" v-on="on">mdi-account-tie</v-icon>
                </template>
                <span>Administrativo</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="Es_Inv" color="primary" v-on="on">mdi-account-star</v-icon>
                </template>
                <span>Investigador</span>
            </v-tooltip>

            <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                    <v-icon v-if="Es_Externo" color="primary" v-on="on">mdi-account</v-icon>
                </template>
                <span>Externo</span>
            </v-tooltip>
    

        <v-divider></v-divider>
        <CerrarSesion class="my-1" :logout="signOutOidc" />

    </v-card>
</v-menu>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapState
} from 'vuex'

import {
    CerrarSesion
} from '@/components/layout'

export default {
    mounted() {
        console.log(this.empleadoDatos)
        this.nombre = this.oidcUser.name
        this.Es_Acad = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Acad) 
        this.Es_Admtvo = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Admtvo) 
        this.Es_Alumno = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Alumno) 
        this.Es_Externo = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Externo) 
        this.Es_Inv = parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Inv) 
        
        // console.log(parseInt(JSON.parse(this.empleadoDatos.Profile).Es_Admtvo) )
    },
    components: {
        CerrarSesion
    },
    data: () => ({
        menu: false,
        nombre: "",
        Es_Acad: 0,
        Es_Admtvo: 0,
        Es_Alumno: 0,
        Es_Externo: 0,
        Es_Inv: 0,
    }),
    props: {
        nue: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapState(['empleadoDatos']),
      ...mapGetters({
        oidcUser:'oidcStore/oidcUser'
        
    })
    },
    methods: {
        ...mapActions({
            signOutOidc: 'oidcStore/signOutOidc'
            
        })
    }

}
</script>
